import React from 'react'

function ShowInvoices() {
  return (
    <div>ShowInvoices</div>
  )
}

export default ShowInvoices